export default __webpack_public_path__ + "static/media/wildlife04.68be2c21.png";